<script setup lang="ts">
import type {  CmsElementCrossSelling } from "@shopware/composables";

import ProductsSlider from "~/components/cms/ProductsSlider.vue";

const props = defineProps<{
  content: CmsElementCrossSelling;
}>();

const crossSellingProducts = ref('');

const crossSellCollections = computed(() => {
  return (
      props.content?.data?.crossSellings?.filter(
          (collection) => !!collection?.products?.length
      ) || []
  );
});

onMounted( ()=> {
  const crossSellFamily = crossSellCollections?.value?.filter(item => item.crossSelling?.name !== 'Modellfamilie');
  crossSellingProducts.value = crossSellFamily ? crossSellFamily[0]?.products : null
})

</script>

<template>
  <section class="section section-main section--solid section-products section-products--alt" :style="props.style" :class="props.class" v-if="crossSellingProducts.length">
    <div class="container">
      <header class="section__head">
        <h2></h2>
      </header><!-- /.section__head -->
      <div class="section__body product-slider">
        <ProductsSlider :slides="crossSellingProducts" />
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>
